module.exports = __webpack_public_path__ + "img/W-C37.941fea41.jpg";